import React from 'react';
import { IconProps } from './types';

const EscalationUserIcon: React.FC<IconProps> = props => {
  const { width = 24, height = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="14" fill="#FFEBEB" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 6.125C15.9367 6.125 17.5 7.68833 17.5 9.625C17.5 11.5617 15.9367 13.125 14 13.125C12.0633 13.125 10.5 11.5617 10.5 9.625C10.5 7.68833 12.0633 6.125 14 6.125ZM14 22.6917C11.0833 22.6917 8.505 21.1983 7 18.935C7.035 16.6133 11.6667 15.3417 14 15.3417C16.3217 15.3417 20.965 16.6133 21 18.935C19.495 21.1983 16.9167 22.6917 14 22.6917Z"
        fill="#E92C2C"
      />
    </svg>
  );
};

export default EscalationUserIcon;
